import React from "react";

import { SvgComponentProps } from "../GenericIconType";
import { SvgWrapper } from "../styles";

const DefaultAgent = (props: SvgComponentProps) => {
  const { width = 20, height = 20, color = "#00A49F", widthBoxView, heightBoxView } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox={`0 0 ${widthBoxView || width} ${heightBoxView || height}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.1667 17.5V15.8333C14.1667 14.9493 13.8155 14.1014 13.1904 13.4763C12.5652 12.8512 11.7174 12.5 10.8333 12.5H4.16667C3.28261 12.5 2.43476 12.8512 1.80964 13.4763C1.18452 14.1014 0.833336 14.9493 0.833336 15.8333V17.5M17.5 17.5V15.8333C17.4993 15.0948 17.2539 14.3773 16.8 13.7936C16.3461 13.2099 15.7093 12.793 14.9917 12.6083M12.3250 2.60833C13.0443 2.79192 13.6829 3.20892 14.1381 3.79359C14.5932 4.37827 14.8395 5.09736 14.8395 5.8375C14.8395 6.57764 14.5932 7.29673 14.1381 7.88141C13.6829 8.46608 13.0443 8.88308 12.3250 9.06667M10.8333 5.83333C10.8333 7.67428 9.34095 9.16667 7.5 9.16667C5.65905 9.16667 4.16667 7.67428 4.16667 5.83333C4.16667 3.99238 5.65905 2.5 7.5 2.5C9.34095 2.5 10.8333 3.99238 10.8333 5.83333Z"
          stroke={color}
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgWrapper>
  );
};

export default DefaultAgent;
